var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNavFilter = function SvgIconNavFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.441 4.221a.755.755 0 0 1 1.068 0l3.22 3.22A.755.755 0 1 1 9.66 8.51L7.73 6.577v12.668a.755.755 0 0 1-1.51 0V6.577L4.288 8.509A.755.755 0 0 1 3.221 7.44l3.22-3.22ZM17.559 19.779a.755.755 0 0 1-1.068 0l-3.22-3.22a.755.755 0 1 1 1.068-1.068l1.931 1.932V4.755a.755.755 0 0 1 1.51 0v12.668l1.932-1.931a.755.755 0 0 1 1.067 1.067l-3.22 3.22Z",
    fill: "#242526"
  })));
};
export default SvgIconNavFilter;